import * as React from 'react';
import { Route, Routes, useParams } from "react-router-dom"
import { Websites } from './Websites';
import { MainForm } from './MainForm';
import { Deploy } from './Deploy';
import { PageForm, HomePageForm } from './PageForm';
import { Website } from './Website';
import { NotFound } from '../NotFound';
import { JsonLDForm } from './JsonLDForm';
import { AppSection } from '../../components/AppSection';
import { PageFormRaw, MainFormRaw, HomePageFormRaw, JsonLDRaw } from './PageFormRaw';
import { StaticFileStringEditor } from '../../components/Websites/StaticFileStringEditor';

function PageRoute() {
    const params = useParams();
    return (<PageForm websiteKey={params.site!} collectionKey={params.collection!} pageKey={params.page!} />);
}

function HomePageRoute() {
    const params = useParams();
    return (<HomePageForm websiteKey={params.site!} />);
}

function HomePageRawRoute() {
    const params = useParams();
    return (<HomePageFormRaw websiteKey={params.site!} />);
}

function StaticFileEditorRoute({ assets }: { assets: boolean }) {
    const params = useParams();
    const path = params['*'] || '';
    return (<StaticFileStringEditor websiteKey={params.site!} path={path} assets={assets} />);
}

function PageRawRoute() {
    const params = useParams();
    return (<PageFormRaw websiteKey={params.site!} collectionKey={params.collection!} pageKey={params.page!} />);
}

function WebsiteRoute() {
    const params = useParams();
    return (<Website websiteKey={params.site!} />);
}

function JsonLDRoute() {
    const params = useParams();
    return (<JsonLDForm websiteKey={params.site!} itemKey={params.item!} />);
}

function JsonLDRawRoute() {
    const params = useParams();
    return (<JsonLDRaw websiteKey={params.site!} itemKey={params.item!} />);
}

function MainFormRoute() {
    const params = useParams();
    return (<MainForm websiteKey={params.site!} />);
}

function MainFormRawRoute() {
    const params = useParams();
    return (<MainFormRaw websiteKey={params.site!} />);
}

function DeployRoute() {
    const params = useParams();
    return (<Deploy websiteKey={params.site!} />);
}

export class SkeletonBootstrap extends React.Component<any,any>{

    public render(){

        return (<React.Fragment>
            <AppSection section="websites/skeleton-bootstrap-5-2" />
            <Routes>
                <Route path=":site/deploy" element={<DeployRoute />} />
                <Route path=":site/main-form/raw" element={<MainFormRawRoute />} />
                <Route path=":site/main-form" element={<MainFormRoute />} />
                <Route path=":site/home" element={<HomePageRoute />} />
                <Route path=":site/home/raw" element={<HomePageRawRoute />} />
                <Route path=":site/collection/:collection/:page/raw" element={<PageRawRoute />} />
                <Route path=":site/static-file-editor/*" element={<StaticFileEditorRoute assets={false} />} />
                <Route path=":site/assets-file-editor/*" element={<StaticFileEditorRoute assets={true} />} />
                <Route path=":site/collection/:collection/:page" element={<PageRoute />} />
                <Route path=":site/jsonld/:item" element={<JsonLDRoute />} />
                <Route path=":site/jsonld/:item/raw" element={<JsonLDRawRoute />} />
                <Route path=":site" element={<WebsiteRoute />} />
                <Route path="" element={<Websites />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </React.Fragment>)
    }
}
